<!-- Icon used by commercial property cards, commercial detail pages, and brokerage detail pages. -->
<template>
	<span :class="iconClasses" class="listing-item-icon"></span>
</template>

<script>
export default {
	props: {
		color: {
			type: String,
			default: 'green500'
		},
		icon: {
			type: String,
			default: 'land'
		},
		size: {
			type: String,
			default: 'm'
		}
	},
	computed: {
		iconClasses() {
			return this.color + ' icon-' + this.size + '-' + this.icon
		}
	}
};
</script>
